import { render, staticRenderFns } from "./WithJDG.vue?vue&type=template&id=4e56f984&scoped=true&"
import script from "./WithJDG.vue?vue&type=script&lang=js&"
export * from "./WithJDG.vue?vue&type=script&lang=js&"
import style0 from "./WithJDG.vue?vue&type=style&index=0&id=4e56f984&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56f984",
  null
  
)

export default component.exports